export enum IdnowFileCheckStatus {
  NONE = 'NONE',
  OK = 'OK',
  WARN = 'WARN',
  ERROR = 'ERROR',
  OBSOLETE = 'OBSOLETE',
}

export enum IdnowFileCheckType {
  DOCUMENT_VALIDITY = 'DOCUMENT_VALIDITY',
  DOCUMENT_ACCEPTABILITY = 'DOCUMENT_ACCEPTABILITY',
  DATA_ACCEPTABILITY = 'DATA_ACCEPTABILITY',
  DATA_CONSISTENCY = 'DATA_CONSISTENCY',
  FILE_COMPLETENESS = 'FILE_COMPLETENESS',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN',
}
